import WhitelistPageContent from './WhitelistPageContent'
import Page from '../../layout/Page'

const WhitelistPage = () => <Page content={<WhitelistPageContent />} />

export default WhitelistPage
